import { Either } from 'src/utils/either';
import { endpoints } from 'src/utils/axios';

// import { _pointsNotificationMock } from 'src/_mock/user/points';
import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class UserRepository {
  constructor(private api: HttpTypes.HttpClient) { }

  async login(body: {
    code: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.auth.login,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getUserPointsNotifications(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.wallet.userPointsNotifications,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async userData(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.auth.userData,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async myBalance(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.wallet.myBalance,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async termsCheck(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.auth.termsCheck,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async termsAccept(
    termsVersion: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.auth.termsAccept,
      params: {
        termsVersion,
      } as any,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async sendSuggestion(body: {
    suggestion: string;
    area: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.benefits.suggestion.sendSuggestion,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async deleteAccount(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'delete',
      url: endpoints.auth.deleteAccount,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getPaymentErrorCount(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.auth.paymentErrorCount,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async postPaymentError(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.auth.paymentFailure,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getDeeplinks(params: {
    page: string;
    origin: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.auth.deeplink,
      params: params as any,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updatePhoto(
    url: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.auth.updatePhoto,
      body: {
        url,
      },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateUser(user: { doubleVerification: boolean }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.auth.updateUser,
      body: user,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getMemberCard(params?: any): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.auth.myMemberCard,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async confirmOnboarding(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.auth.confirmOnboarding,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getConfig(
    name: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.auth.getConfig,
      params: {
        name,
      } as any,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getPromotionOptin(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.auth.getPromotionOption,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
